// extracted by mini-css-extract-plugin
module.exports = {"label":"ShippingOptionLabel_label__nHzGh","labelText":"ShippingOptionLabel_labelText__wl2Vs","price":"ShippingOptionLabel_price__59PUV"};